<template>
  <div class="pdfBox">
    <div class="topBox" @click.stop="">
      可通过 Ctrl+F键 快速查询并定位内容,或者 Ctrl+鼠标滚轮 进行放大缩小
    </div>
    <iframe ref="iframe" height="100%" width="100%" style="position: absolute;" src="/pdf/illustrate.pdf"
      frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
.pdfBox {
  position: relative;
  height: 86vh;

  .topBox {
    position: absolute;
    top: 0;
    width: 100%;
    height: 40px;
    background-color: #323639 !important;
    z-index: 99;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
